import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import actionTypes from 'constants/actionTypes';

import { usePublishTradingOfferModal } from '../context/PublishTradingOfferModalContext';

import PublishTradingOfferModalStep1 from './PublishTradingOfferModalStep1';
import PublishTradingOfferModalStep2 from './PublishTradingOfferModalStep2';

const getStepLiClassName = (stepNumber: number, currentStep: number) => {
  if (stepNumber === currentStep) return 'current';
  if (stepNumber < currentStep) return 'done';
  return '';
};

const PublishTradingOfferModalBody: FC = () => {
  const { t } = useTranslate();
  const { data } = usePublishTradingOfferModal();

  const isReadOnlyView = data.modalActionType === actionTypes.VIEW;

  if (isReadOnlyView) {
    return (
      <Modal.Body className="py-4">
        <PublishTradingOfferModalStep1 />
      </Modal.Body>
    );
  }

  return (
    <Modal.Body className="py-4">
      <ul className="nk-stepper-nav nav nav-tabs nav-tabs-s2 accept-trading-offer-stepper mb-4 list-unstyled d-flex w-100">
        <li
          className={`${getStepLiClassName(1, data.currentStep)} flex-grow-1`}
          data-step="1"
        >
          <span className="step-item">
            <span className="step-text">{t('Summary')}</span>
          </span>
        </li>
        <li
          className={`${getStepLiClassName(2, data.currentStep)} flex-grow-1`}
          data-step="2"
        >
          <span className="step-item">
            <span className="step-text">{t('Verification')}</span>
          </span>
        </li>
      </ul>

      <div className="nk-stepper-content">
        <div className="nk-stepper-steps stepper-steps">
          {data.currentStep === 1 && <PublishTradingOfferModalStep1 />}
          {data.currentStep === 2 && <PublishTradingOfferModalStep2 />}
        </div>
      </div>
    </Modal.Body>
  );
};

export default PublishTradingOfferModalBody;
